import { useLayoutEffect, RefObject } from 'react';

const contain = (target: HTMLElement) => (ref: RefObject<HTMLElement | null>) => ref.current?.contains(target);

export function useEventOutside(
  eventType: string,
  ref: RefObject<HTMLElement | null> | RefObject<HTMLElement | null>[],
  handler: (event: Event) => void,
  enabled = true,
) {
  useLayoutEffect(() => {
    if (!enabled || !ref) {
      return () => undefined;
    }
    const listener = (event: Event) => {
      const target = event.target as HTMLElement | null;
      if (!target) return;
      const refs = Array.isArray(ref) ? ref : [ref];
      const isInside = refs.some(contain(target));
      if (!isInside) handler(event);
    };
    document.addEventListener(eventType, listener, { capture: true });
    return () => document.removeEventListener(eventType, listener, { capture: true });
  }, [enabled, eventType, handler, ref]);
}
